export enum SellsFilter {
    day,
    week,
    month,
    all,
}